import { authHeader, forDownload } from "../_helpers";

const BASE_URL = process.env.REACT_APP_BASE_URL;

function getTestImages(testImage) {
  const testId = testImage.id;
  const position = testImage?.data;

  const requestOptions = {
    method: "GET",
    headers: { ...authHeader() },
  };

  const endPoint = `/api/admin/v1/tests/${testId}`;

  const imageData = position.map((item) => {
    return fetch(
      `${BASE_URL}${endPoint}/image/${item.position}`,
      requestOptions
    )
      .then(forDownload)
      .then((data) => {
        const imgData = {
          ...data,
        };
        imgData.label = item.label;
        if (item.name) {
          imgData.name = item.name;
        }
        return imgData;
      });
  });
  return Promise.all(imageData).then((values) => {
    return values;
  });
}
export const testImageService = {
  getTestImages,
};
